import API from "../../../utils/api";


export const getTrendingColoursApi = async (filters) => {
    const response = await API.get('settings/trending-colours', {params: filters});
    return {response};
};

export const sortTrendingColoursApi = async (payload) => {
    const response = await API.post('settings/trending-colours/sort', payload);
    return {response};
};

export const toggleTrendingColourApi = async (id, payload) => {
    const response = await API.post(`settings/trending-colours/${id}/toggle`, payload);
    return {response};
};

export const setTrendingColourOrderApi = async (id, payload) => {
    const response = await API.post(`settings/trending-colours/${id}/sort-order`, payload);
    return {response};
};
